var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "msg-subscr-msanage" }, [
      _c("div", { staticClass: "hint block mb10" }, [
        _c("div", { staticClass: "title" }, [_vm._v("温馨提示")]),
        _vm._v(" "),
        _c("p", [_vm._v("逐条检查：一条一条的检查，因数据较多花费时间较长")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block mb10" }, [
        _c("p", [
          _vm._v("逐条检查导入：一条一条的检查并导入，因数据较多花费时间较长")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hint block" }, [
        _c("p", [_vm._v("导入excel文件的单元格格式推荐使用常规或文本")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "message-body mt10" }, [
        _c("ul", { staticClass: "native-table" }, [
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("列名")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-th", staticStyle: { width: "120px" } },
              [_vm._v("是否必填")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-th",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("其他要求")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-th" }, [_vm._v("不符合要求的结果")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("供应商名称")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "必填，可在系统中手动修改，导入列中不可重复且不可与系统同供应商名称重复"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("统一社会信用代码")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("必填，可在系统中手动修改，导入列中不可重复")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("省")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("否")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("市")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("否")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("县/区")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("否")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("详细地址")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("否")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("联系人")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("否")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("联系手机号")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [
                _vm._v(
                  "必填，可在系统中手动修改，导入列中不可重复且不可与其他商户管理员账号相同"
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("验证不通过")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("联系邮箱")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("否")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("可在系统中手动输入")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("关系开始日期")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("格式 yyyy-MM-dd，可在系统中手动设置")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("关系截止日期")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("格式 yyyy-MM-dd，可在系统中手动设置")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("评级")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("数字1~5,可在系统中手动设置")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "table-tr" }, [
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("业务描述")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v("是")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-td",
                staticStyle: { "text-align": "left" }
              },
              [_vm._v("最多60个字符，可在系统中手动填写")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-td" }, [_vm._v(" - ")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-436410f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-436410f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/merchant/VendorFormatExpl.vue
// module id = 3313
// module chunks = 0